import React from 'react'
import Header from './Header'
import Main from './Main'
import Footer from './Footer'
import './assets/css/Main.css';
import './assets/css/Pages.css';


class App extends React.Component{
  constructor(props) {
    super(props);
  }

  render(){
    return(
      AppJSX(this)
    );
  }
}

const AppJSX = (ctx) => ([
  <div className="content" key="1">
    <Header />
    <Main updateLangByMain={ctx.updateLangByMain} />
  </div>,
  <Footer key="2" />
])

export default App



// WEBPACK FOOTER //
// ./src/components/App.js